import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { AppConfig } from '../../app.config';
import { MenuItem } from 'primeng/api';
import { map } from 'rxjs/operators';

@Injectable()
export class MenuService {
    constructor(private _appConfig: AppConfig, private _httpClient: HttpClient){}

    private menuSource = new Subject<string>();
    private resetSource = new Subject();

    menuSource$ = this.menuSource.asObservable();
    resetSource$ = this.resetSource.asObservable();

    onMenuStateChange(key: string) {
        this.menuSource.next(key);
    }

    reset() {
        this.resetSource.next(null);
    }

    fetchMenu(): Observable<MenuItem[]> {
        return this._httpClient.get<MenuItem[]>(this._appConfig.apiEndpoint + 'menu/getmenuitems').pipe(
            map(menuItems => {
                return menuItems;
            })
        ) as Observable<MenuItem[]>;
    }
}
